<script>
import _ from 'lodash';
import * as VueScrollTo from 'vue-scrollto';

export default {
  name: 'ValidationObserver',
  data() {
    return {
      observables: [],
    };
  },
  mounted() {
    this.$emit('observe', this);
  },
  destroyed() {
    this.$emit('unobserve', this);
  },
  methods: {
    observe(component) {
      this.observables.push(component);
    },
    unobserve(component) {
      _.remove(this.observables, ob => ob === component);
    },
    scrollTo(element) {
      const options = {
        container: '#scrollablePage',
        force: true,
        x: false,
        y: true,
        offset: -100,
      };

      VueScrollTo.scrollTo(element, 0, options);
    },
    async validate() {
      // We intentionally do not break the validation loop on the first invalid result, since
      // we want to call `validate` on all registered observables and show validation errors
      // where necessary
      const validationResults = await Promise.all(_.map(this.observables, async observable => {
        const validationResult = await observable.validate();
        return { element: observable.$el, result: validationResult };
      }));
      const firstInvalidObservable = _.find(validationResults, validationResult => !validationResult.result.valid);
      if (firstInvalidObservable) {
        this.scrollTo(firstInvalidObservable.element);
        return { valid: false };
      }
      return { valid: true };
    },
  },
};
</script>
